import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { format, formatDistanceToNow, millisecondsToMinutes } from 'date-fns';
import { getTimezoneOffset, utcToZonedTime } from 'date-fns-tz';
import jwt from 'jsonwebtoken';
import _ from 'lodash';

import { RootState } from '../../../../configs/store';
import { timezones, oddTypes } from '../../../../utils/content';
import MenuItem from '../MenuItem/MenuItem';
import WalletMenuItem from '../MenuItem/WalletMenuItem';

function BetsiteTopMenu() {
  const { languages, selectedTimezone, selectedOddsType, selectedLanguage } = useSelector((state: RootState) => state.odds);
  const { authenticated } = useSelector((state: RootState) => state.auth);

  const [timer, setTimer] = useState(() => {
    const zonedDate = utcToZonedTime(new Date().toISOString(), selectedTimezone);
    return format(zonedDate, 'dd.M.yyyy, HH:mm');
  });
  const { t } = useTranslation('common');

  const updateTimer = () => {
    const zonedDate = utcToZonedTime(new Date().toISOString(), selectedTimezone);
    const newTimer = format(zonedDate, 'dd.M.yyyy, HH:mm');
    if (newTimer !== timer) {
      setTimer(newTimer);
    }
  };
  const timerInterval = setInterval(updateTimer, 1000);

  const tokenIat = localStorage.getItem('token') && jwt.decode(localStorage.getItem('token'));

  const prettyTimezones = useMemo(() => {
    return _.sortBy(_.map(timezones, timezone => {
      const offsetInMin = millisecondsToMinutes(getTimezoneOffset(timezone.value));
      const m = offsetInMin % 60;
      const h = (offsetInMin - m) / 60;
      const hhmm = `${ h }:${ Math.abs(m) < 10 ? 0 : '' }${ Math.abs(m) }`;

      return {
        ...timezone,
        label: `(GMT ${ offsetInMin < 0 ? hhmm : `+${ hhmm }` }) ${ timezone.label }`,
        offset: offsetInMin
      };
    }), 'offset');
  }, [timezones]);

  useEffect(() => {
    return () => {
      clearInterval(timerInterval);
    };
  }, [authenticated, timerInterval]);

  useEffect(() => {
    const zonedDate = utcToZonedTime(new Date().toISOString(), selectedTimezone);
    const newTimer = format(zonedDate, 'dd.M.yyyy, HH:mm');
    if (newTimer !== timer) {
      setTimer(newTimer);
    }
  }, [selectedTimezone]);

  return (
    <>
      <MenuItem type="odds" items={ oddTypes } selected={ selectedOddsType } />
      <MenuItem type="language" items={ languages } selected={ selectedLanguage } />
      <MenuItem type="timezone" items={ prettyTimezones } selected={ selectedTimezone } />
      <MenuItem type="help" />
      { authenticated && <WalletMenuItem /> }

      <div className="top-menu__item top-menu__item--clock">
        {
          authenticated &&
        tokenIat && (
            <span>{ t('topmenu.signedInFor') } <strong>{ formatDistanceToNow(tokenIat['iat'] * 1000) }</strong></span>
          )
        }
        <span>{ timer }</span>
      </div>
    </>
  );
}

export default BetsiteTopMenu;
